// UpdateDialog.tsx
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";


interface Props {
  open: boolean;
  onConfirm: () => void;
}

export function UpdateDialog({ open, onConfirm }: Props) {
  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update available</DialogTitle>
          <DialogDescription>
            A new version of this app is available. Please refresh to get the latest version.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onConfirm}>Refresh</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
